export enum MarketingInteractionTypeEnum {
	RegisterConfirm = "marketing-register-confirm",
	RegisterClose = "marketing-register-close",
	NewsletterConfirm = "marketing-newsletter-confirm",
	NewsletterClose = "marketing-newsletter-close",
}
